var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOvalMobile(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 152,
    height: 157,
    viewBox: "0 0 152 157",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.5581 114.551C1.92456 98.3539 11.0827 76.5922 36.5542 61.8776C52.5559 44.3519 78.9009 59.454 97.5344 75.6514C116.168 91.8488 106.066 114.644 90.0644 132.17C74.0627 149.696 39.1916 130.749 20.5581 114.551Z",
    fill: "#002668"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M152 87.6854C152 121.703 117.084 132.605 73.7882 120.354C36.8603 120.354 27.6992 79.5058 27.6992 45.4885C27.6992 11.4712 64.793 0.569336 101.721 0.569336C138.649 0.569336 152 53.6681 152 87.6854Z",
    fill: "#D9D9D9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOvalMobile);
export default __webpack_public_path__ + "static/media/oval-mobile.3e423d266d39ec8112184ae2fc437ad7.svg";
export { ForwardRef as ReactComponent };